import { SIMPLE_GU } from "./simple";

export const gu = {
  ...SIMPLE_GU,
  "Dashboard": "ડેશબોર્ડ",
  "Daily Reports": "દૈનિક રિપોર્ટ",
  "Business": "બિઝનેસ",
  "Lottery": "લોટરી",
  "Bank": "બેંક",
  "Reports": "રિપોર્ટ્સ",
  "Settings": "સેટિંગ્સ",
  "Gas Reports": "ગેસ રિપોર્ટ",
  "Start Daily Report": "દૈનિક રિપોર્ટ શરૂ કરો",
  "Cash Transactions": "કેશ વ્યવહારો",
  "Inventory": "ઇન્વેન્ટરી",
  "Lotto Reports": "લોટો રિપોર્ટ",
  "Business Reports": "બિઝનેસ રિપોર્ટ",
  "Gas Daily Report": "ગેસ દૈનિક રિપોર્ટ",
  "Gas Sales Report": "ગેસ વેચાણ રિપોર્ટ",
  "Gas Variance Report": "ગેસ તફાવત રિપોર્ટ",
  "Gas Inventory": "ગેસ ઇન્વેન્ટરી",
  "Gas Settings": "ગેસ સેટિંગ્સ",
  "Invoices": "બિલ (ઇન્વૉઇસ)",
  "Vendors": "વેન્ડર્સ",
  "Categories": "કેટેગરી",
  "Payroll": "પગાર",
  "Customers": "ગ્રાહકો",
  "Other Income": "અન્ય આવક",
  "ATM Deposit": "ATM ડિપોઝિટ",
  "Ownership": "માલિકી",
  "Lotto Sales Report": "લોટો વેચાણ રિપોર્ટ",
  "Books in Stock": "સ્ટોકમાં બુક્સ",
  "All Books Received": "મળેલી બધી બુક્સ",
  "Active Inventory": "સક્રિય ઇન્વેન્ટરી",
  "Books Sold": "વેચાયેલી બુક્સ",
  "Game Information": "ગેમ માહિતી",
  "Sales Report": "વેચાણ રિપોર્ટ",
  "Shift Reports": "શિફ્ટ રિપોર્ટ",
  "Weekly Reports": "સાપ્તાહિક રિપોર્ટ",
  "Monthly Reports": "માસિક રિપોર્ટ",
  "Yearly Reports": "વાર્ષિક રિપોર્ટ",
  "Cash Shift Reports": "કેશ શિફ્ટ રિપોર્ટ",
  "All Activity Reports": "બધી પ્રવૃત્તિ રિપોર્ટ",
  "Store Settings": "સ્ટોર સેટિંગ્સ",
  "User Settings": "યુઝર સેટિંગ્સ",
  "User Role Settings": "યુઝર રોલ સેટિંગ્સ",
  "Billing": "બિલિંગ",
  "Home": "હોમ",
  "Shift": "શિફ્ટ",
  "Scan": "સ્કેન",
  "Report": "રિપોર્ટ",
  "Menu": "મેનુ",
  "Start Shift": "શિફ્ટ શરૂ કરો",
  "Add Inventory": "ઇન્વેન્ટરી ઉમેરો",
  "Scan Tickets": "ટિકિટ સ્કેન કરો",
  "Activation": "એક્ટિવેશન",
  "Confirm Sold": "વેચાયેલી પુષ્ટિ",
  "Returned Books": "પરત કરેલી બુક્સ",
  "Lotto Report": "લોટો રિપોર્ટ",
  "Business Report": "બિઝનેસ રિપોર્ટ",
  "Gas Daily Reports": "ગેસ દૈનિક રિપોર્ટ",
  "Back": "પાછળ",
  "Next": "આગળ",
  "Save Report": "રિપોર્ટ સેવ કરો",
  "Save & Finalize Shift": "સેવ કરી શિફ્ટ પૂર્ણ કરો",
  "Print / Text Snapshot": "પ્રિન્ટ / ટેક્સ્ટ સ્નેપશોટ",
  "Save": "સેવ",
  "Cancel": "રદ કરો",
  "Add": "ઉમેરો",
  "Delete": "કાઢી નાખો",
  "Save Settings": "સેટિંગ્સ સેવ કરો",
  "Sign out": "સાઇન આઉટ",
  "Change shift / date": "શિફ્ટ / તારીખ બદલો",
  "Shift Date": "શિફ્ટ તારીખ",
  "Select Shift": "શિફ્ટ પસંદ કરો",
  "Finalized": "પૂર્ણ",
  "Open": "ખુલ્લી",
  "Lottery Shift": "લોટરી શિફ્ટ",
  "Business Shift": "બિઝનેસ શિફ્ટ",
  "Note": "નોંધ",
  "Amount": "રકમ",
  "Customer Name": "ગ્રાહકનું નામ",
  "Type": "પ્રકાર",
  "Search…": "શોધો…",
  "Action": "ક્રિયા",
  "Status": "સ્થિતિ",
  "Total": "કુલ",
  "Date": "તારીખ",
  "Total Lotto Sales": "કુલ લોટો વેચાણ",
  "Report Cash Balance": "રિપોર્ટ કેશ બેલેન્સ",
  "Cash On Hand": "હાથમાં કેશ",
  "Over / Short": "વધુ / ઓછું",
  "Over/Short": "વધુ/ઓછું",
  "Online Report": "ઓનલાઇન રિપોર્ટ",
  "Report Amount": "રિપોર્ટ રકમ",
  "Last Shift $": "ગત શિફ્ટ $",
  "Current Shift $": "આ શિફ્ટ $",
  "Net Sales": "નેટ વેચાણ",
  "Online Cashing": "ઓનલાઇન કેશિંગ",
  "Balance": "બેલેન્સ",
  "Instant Cashing": "ઇન્સ્ટન્ટ કેશિંગ",
  "Cash Reconciliation": "કેશ મેળ",
  "Total Sales (1+2)": "કુલ વેચાણ (1+2)",
  "Less: Total Cashing": "બાદ: કુલ કેશિંગ",
  "Less: Total Cash Paid Out": "બાદ: કુલ કેશ ચૂકવણી",
  "Add: Other Cash Receipts": "ઉમેરો: અન્ય કેશ આવક",
  "Total Customer Paid Back": "ગ્રાહકે પરત ચૂકવ્યું",
  "Total Customer Credits": "ગ્રાહક ઉધાર",
  "Cash On Hand (counted)": "હાથમાં કેશ (ગણેલી)",
  "Instant Report · Active Inventory": "ઇન્સ્ટન્ટ રિપોર્ટ · સક્રિય ઇન્વેન્ટરી",
  "Online Report · Total": "ઓનલાઇન રિપોર્ટ · કુલ",
  "Instant Balance · Inactive Inventory": "ઇન્સ્ટન્ટ બેલેન્સ · નિષ્ક્રિય ઇન્વેન્ટરી",
  "Customer Transactions": "ગ્રાહક વ્યવહારો",
  "Less: Inventory Returned": "બાદ: પરત ઇન્વેન્ટરી",
  "Online Sales (2)": "ઓનલાઇન વેચાણ (2)",
  "Cashes": "કેશિંગ",
  "Paid Back": "પરત ચૂકવ્યું",
  "Credit Given": "ઉધાર આપ્યું",
  "Shifts on this day": "આ દિવસની શિફ્ટો",
  "Shift Check": "શિફ્ટ ચકાસણી",
  "No mistakes found – this shift looks clean.": "કોઈ ભૂલ મળી નથી – આ શિફ્ટ બરાબર લાગે છે.",
  "Fix": "સુધારો",
  "Sales Entry": "વેચાણ એન્ટ્રી",
  "Shift Detail": "શિફ્ટ વિગત",
  "Sales": "વેચાણ",
  "Per POS report": "POS રિપોર્ટ મુજબ",
  "Collected": "વસૂલ",
  "Sales Tax": "સેલ્સ ટેક્સ",
  "Refund": "રિફંડ",
  "Credit Card Per POS": "POS મુજબ ક્રેડિટ કાર્ડ",
  "Other/Checks Per POS": "POS મુજબ અન્ય/ચેક",
  "Cash Per POS": "POS મુજબ કેશ",
  "Credit Cards Collected": "ક્રેડિટ કાર્ડ વસૂલ",
  "Other/Checks Collected": "અન્ય/ચેક વસૂલ",
  "Customer Credit": "ગ્રાહક ઉધાર",
  "Gross Sales": "કુલ વેચાણ",
  "Total Per POS": "POS મુજબ કુલ",
  "Total Collected": "કુલ વસૂલ",
  "Gross Sales (Net + Tax + Refund)": "કુલ વેચાણ (નેટ + ટેક્સ + રિફંડ)",
  "Total Sales Per POS": "POS મુજબ કુલ વેચાણ",
  "Add: Customer Credit": "ઉમેરો: ગ્રાહક ઉધાર",
  "Balance Per Report": "રિપોર્ટ મુજબ બેલેન્સ",
  "Total Collected (Cash + CC + Other)": "કુલ વસૂલ (કેશ + કાર્ડ + અન્ય)",
  "Started On": "શરૂ થયું",
  "Started By": "શરૂ કરનાર",
  "Ended On": "પૂર્ણ થયું",
  "Finalized By": "પૂર્ણ કરનાર",
  "Add New Inventory": "નવી ઇન્વેન્ટરી ઉમેરો",
  "Scan the book barcode": "બુકનો બારકોડ સ્કેન કરો",
  "Add new game": "નવી ગેમ ઉમેરો",
  "New Inventory Received This Shift": "આ શિફ્ટમાં મળેલી નવી ઇન્વેન્ટરી",
  "Books Received": "મળેલી બુક્સ",
  "Inventory Value": "ઇન્વેન્ટરી મૂલ્ય",
  "Game Number": "ગેમ નંબર",
  "Book Serial Number": "બુક સિરિયલ નંબર",
  "Game Name": "ગેમનું નામ",
  "Ticket Amount": "ટિકિટ કિંમત",
  "Ticket Qty": "ટિકિટ સંખ્યા",
  "Book Amount": "બુક રકમ",
  "Received Date": "મળ્યાની તારીખ",
  "Book Status": "બુક સ્થિતિ",
  "Scan Instant Tickets": "ઇન્સ્ટન્ટ ટિકિટ સ્કેન કરો",
  "Confirm Books Activated": "એક્ટિવેટ બુક્સ પુષ્ટિ",
  "Confirm Books Sold": "વેચાયેલી બુક્સ પુષ્ટિ",
  "Returned Books · Back to the Lottery": "પરત બુક્સ · લોટરીને પરત",
  "Scan the book being returned": "પરત કરાતી બુક સ્કેન કરો",
  "Books Returned This Shift": "આ શિફ્ટમાં પરત બુક્સ",
  "Return to lottery": "લોટરીને પરત કરો",
  "Store Information": "સ્ટોર માહિતી",
  "Store Modules": "સ્ટોર મોડ્યુલ્સ",
  "Store Logo": "સ્ટોર લોગો",
  "Live Data Sync": "લાઇવ ડેટા સિંક",
  "Lottery Terminals": "લોટરી ટર્મિનલ્સ",
  "Nightly Email Snapshot": "રાત્રિ ઈમેલ સ્નેપશોટ",
  "Store Users": "સ્ટોર યુઝર્સ",
  "Store Name": "સ્ટોર નામ",
  "Address": "સરનામું",
  "City": "શહેર",
  "State": "રાજ્ય",
  "Zip Code": "ઝિપ કોડ",
  "Website": "વેબસાઇટ",
  "Week starts on": "અઠવાડિયું શરૂ થાય",
  "Store sells Lottery": "સ્ટોર લોટરી વેચે છે",
  "Store sells Gas": "સ્ટોર ગેસ વેચે છે",
  "Store has ATM": "સ્ટોરમાં ATM છે",
  "Language": "ભાષા",
  "Business Sales": "બિઝનેસ વેચાણ",
  "Lottery Sales": "લોટરી વેચાણ",
  "Merchandise Purchased": "માલ ખરીદી",
  "Expenses": "ખર્ચ",
  "Invoices Due": "બાકી બિલ",
  "Top Vendors": "મુખ્ય વેન્ડર્સ",
  "Purchases by Category": "કેટેગરી મુજબ ખરીદી",
  "Sales vs Purchases (by day)": "વેચાણ વિ ખરીદી (દિવસ મુજબ)",
  "This Month": "આ મહિનો",
  'Bank Deposit': 'બેંક ડિપોઝિટ',
  'Checks': 'ચેક',
  'Write a check': 'ચેક લખો',
  'Check register': 'ચેક રજિસ્ટર',
  'Account check setup': 'ખાતા ચેક સેટઅપ',
  'Store Users': 'સ્ટોર યુઝર્સ',
  'Add User to Store': 'સ્ટોરમાં યુઝર ઉમેરો',
  'First Name': 'પ્રથમ નામ',
  'Middle Name': 'મધ્ય નામ',
  'Last Name': 'અટક',
  'Mobile': 'મોબાઇલ',
  'Email (login)': 'ઈમેલ (લોગિન)',
  'Password': 'પાસવર્ડ',
  'Role': 'રોલ',
  'Select User': 'યુઝર પસંદ કરો',
  'Name': 'નામ',
  'Login / Email': 'લોગિન / ઈમેલ',
  'Phone': 'ફોન',
  'Send Email': 'ઈમેલ મોકલો',
  'Week Starts On': 'અઠવાડિયું શરૂ થાય',
  'Instant ticket numbering starts at': 'ઇન્સ્ટન્ટ ટિકિટ નંબર શરૂ થાય',
  'New Terminal Nickname': 'નવું ટર્મિનલ નામ',
  'Terminal': 'ટર્મિનલ',
  'Lottery Vending Machine': 'લોટરી વેન્ડિંગ મશીન',
  'Single lottery shift per day': 'દિવસમાં એક જ લોટરી શિફ્ટ',
  'Over/short alert threshold ($)': 'વધુ/ઓછું ચેતવણી મર્યાદા ($)',
  'Owner WhatsApp number': 'માલિકનો WhatsApp નંબર',
  'Subscription details': 'સબ્સ્ક્રિપ્શન વિગત',
  'Subscription history': 'સબ્સ્ક્રિપ્શન ઇતિહાસ',
  'Payment history': 'ચુકવણી ઇતિહાસ',
  'Current plan': 'વર્તમાન પ્લાન',
  'Days left': 'બાકી દિવસો',
  'Plan': 'પ્લાન',
  'From': 'થી',
  'To': 'સુધી',
  'Paid on': 'ચૂકવ્યું',
  'Settings saved': 'સેટિંગ્સ સેવ થઈ',
  'Report saved': 'રિપોર્ટ સેવ થયો',
  'Lottery shift finalized': 'લોટરી શિફ્ટ પૂર્ણ થઈ',
  'Business shift finalized': 'બિઝનેસ શિફ્ટ પૂર્ણ થઈ',
  'Send to owner on WhatsApp': 'માલિકને WhatsApp પર મોકલો',
  'Read from photo': 'ફોટોમાંથી વાંચો',
  'Reading…': 'વાંચી રહ્યું છે…',
  'Undo': 'પાછું લો',
  'Books Returned This Shift': 'આ શિફ્ટમાં પરત બુક્સ',
  'Value Returned': 'પરત મૂલ્ય',
  'Tickets Returned': 'પરત ટિકિટ',
  'Print / Text Snapshot (full day)': 'પ્રિન્ટ / ટેક્સ્ટ સ્નેપશોટ (પૂરો દિવસ)',
  'Overview': 'ઝાંખી',
  'Books': 'બુક્સ',
  'Games': 'ગેમ્સ',
  'Money': 'પૈસા',
  'Scan new books': 'નવી બુક્સ સ્કેન કરો',
  'Activate a book': 'બુક એક્ટિવેટ કરો',
  'Return a book': 'બુક પરત કરો',
  'Add a game': 'ગેમ ઉમેરો',
  'Selling now': 'હાલમાં વેચાણમાં',
  'Running low': 'સ્ટોક ઓછો',
  'Best sellers · last 7 days': 'સૌથી વધુ વેચાણ · છેલ્લા 7 દિવસ',
  'In stock': 'સ્ટોકમાં',
  'Activated': 'એક્ટિવેટેડ',
  'Sold': 'વેચાયેલ',
  'All books': 'બધી બુક્સ',
  'Pay employee': 'કર્મચારીને ચૂકવણી',
  'Record other income': 'અન્ય આવક નોંધો',
  'In stock by price': 'કિંમત પ્રમાણે સ્ટોક',
  'books': 'બુક્સ',
  'All games': 'બધી ગેમ્સ',
  'Books on the shelf': 'શેલ્ફ પર બુક્સ',
  'Value left to sell': 'વેચવા બાકી કિંમત',
};
